export const PIWIK_PLACEHOLDER_ID = '00000000-0000-0000-0000-000000000000';

export const PIWIK_PROD_CONTAINER_ID = '77bda44f-4f35-4032-9044-f54fe24b513a';

export const PIWIK_STAGE_CONTAINER_ID = 'e10487be-21e8-4300-aa95-fc089b442dc8';

/**
 * Piwik PRO container IDs, keyed by the hostname the site is served from.
 *
 * The ID is resolved in the browser instead of at build time because a single
 * build artifact is served under several hostnames: init builds one Docker
 * image per `gatsby-*` tag and runs it on both stage.lgtcp.com and
 * www.lgtcp.com. Adding a domain therefore means editing this map.
 *
 * Hosts that are not listed fall back to PIWIK_PLACEHOLDER_ID, which loads no
 * container at all.
 */
export const PIWIK_CONTAINER_IDS: Record<string, string> = {
  'www.lgtcp.com': PIWIK_PROD_CONTAINER_ID,
  'stage.lgtcp.com': PIWIK_STAGE_CONTAINER_ID,
  'lgt-cp-stage.amazeelabs.dev': PIWIK_STAGE_CONTAINER_ID,
};

/**
 * Data layer event pushed on client-side navigation, for the Piwik PRO Tag
 * Manager to trigger a virtual page view on.
 */
export const PIWIK_ROUTE_CHANGE_EVENT = 'routeChange';

/**
 * The Piwik PRO Tag Manager snippet, as supplied by the client, with two
 * changes:
 *
 * - the hardcoded container ID becomes a hostname lookup,
 * - the container script is not inserted when the ID is the placeholder.
 *
 * The data layer, its `stg.start` entry and the `ppms` API stubs are always
 * set up, so `dataLayer.push(...)` and `ppms.*.api(...)` are safe on every
 * environment, including local development and CI.
 */
export function piwikSnippet(): string {
  return `
(function(window, document, dataLayerName, ids, placeholder) {
var id=Object.prototype.hasOwnProperty.call(ids,window.location.hostname)?ids[window.location.hostname]:placeholder;
window[dataLayerName]=window[dataLayerName]||[],window[dataLayerName].push({start:(new Date).getTime(),event:"stg.start"});
!function(a,n,i){a[n]=a[n]||{};for(var c=0;c<i.length;c++)!function(i){a[n][i]=a[n][i]||{},a[n][i].api=a[n][i].api||function(){var a=[].slice.call(arguments,0);"string"==typeof a[0]&&window[dataLayerName].push({event:n+"."+i+":"+a[0],parameters:[].slice.call(arguments,1)})}}(i[c])}(window,"ppms",["tm","cm"]);
if(id===placeholder)return;
var scripts=document.getElementsByTagName('script')[0],tags=document.createElement('script');
var qP=[];dataLayerName!=="dataLayer"&&qP.push("data_layer_name="+dataLayerName);var qPString=qP.length>0?("?"+qP.join("&")):"";
tags.async=!0,tags.src="https://lgtcp.containers.piwik.pro/"+id+".js"+qPString,scripts.parentNode.insertBefore(tags,scripts);
})(window, document, 'dataLayer', ${JSON.stringify(
    PIWIK_CONTAINER_IDS,
  )}, '${PIWIK_PLACEHOLDER_ID}');
`;
}
